// extracted by mini-css-extract-plugin
export default {"video-section":"p_bv d-flex","video-section--header":"p_bw","video-section__frame":"p_bx ml-3"};